module.exports = __webpack_public_path__ + "static/media/BTT-BNB.69a4075e.svg";